import { get, post } from './axios.js'

/**
 * 이메일 발신 정보 목록 조회 - /email/sendList
 * @param {object} params
 * @property {string} params.call_prgm_nm
 * @property {string} params.receiver_nm
 * @property {string} params.title
 * @property {string} params.fr_date
 * @property {string} params.to_date
 * @property {string} params.page_count
 * @property {string} params.unit_count
 * @returns
 */
export async function sendList(params = {}) {
  try {
    const result = await post('/email/sendList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 이메일 수신 정보 목록 조회 - /email/receiveList
 * @param {object} params
 * @property {string} params.call_prgm_nm
 * @property {string} params.receiver_nm
 * @property {string} params.title
 * @property {string} params.fr_date
 * @property {string} params.to_date
 * @property {string} params.page_count
 * @property {string} params.unit_count
 * @returns
 */
export async function receiveList(params = {}) {
  try {
    const result = await post('/email/receiveList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 메일발송 처리 - /email/send
 * @param {object} params
 * @property {string} params.call_prgm_nm
 * @property {string} params.receiver_nm
 * @property {string} params.title
 * @property {string} params.fr_date
 * @property {string} params.to_date
 * @property {string} params.page_count
 * @property {string} params.unit_count
 * @returns
 */
export async function send(params = {}) {
  try {
    const result = await post('/email/send', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}